import littlewoods from 'constants/littlewoods';
import verypay from 'constants/verypay';
import { insuranceVoucherMap } from 'constants/promotion-voucher-constants';

type Content = {
  [key: string]: string;
};

export default {
  ...verypay,
  ...littlewoods,
  ...insuranceVoucherMap
  } as Content;
